import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=4ae5c6e8&scoped=true"
import script from "./Approval.vue?vue&type=script&lang=js"
export * from "./Approval.vue?vue&type=script&lang=js"
import style0 from "./Approval.vue?vue&type=style&index=0&id=4ae5c6e8&prod&scoped=true&lang=css"
import style1 from "./Approval.vue?vue&type=style&index=1&id=4ae5c6e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae5c6e8",
  null
  
)

export default component.exports